import { render, staticRenderFns } from "./SecondaryYN.vue?vue&type=template&id=fc1b17f0"
import script from "./SecondaryYN.vue?vue&type=script&lang=js"
export * from "./SecondaryYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports